<template>
	<div v-if="currentSong && currentSong.content" id="export-detail">
		<div id="export-detail-scroll">
			<h1>{{ currentSong.title }} <small>{{ currentSong.author }}</small></h1>
			<div style="margin-left: -20px">
				<SongContentKytaristka  :style="{ fontSize: '1.05em' }" :song="currentSong" />
			</div>
		</div>
	</div>
</template>

<script>
	import { SongDetailMixin } from "@/mixins/SongDetailMixin";
	import axios from "axios";
	import SongContentKytaristka from "@/components/detail/SongContentKytaristka";

	export default {
		components: {SongContentKytaristka},
		data() {
			return {
				currentSong: null
			}
		},
		mixins: [
			SongDetailMixin
		],
		mounted() {
			this.$store.commit("setLoading", false);
			axios.request({
				url: `https://server.mangozpevnik.cz/songExport/${this.$route.params.song}.json`,
				method: "get"
			}).then(res => {
				this.currentSong = res.data.song;
			})
		}
	}
</script>

<style lang="scss">
	#export-detail {
		margin: 0;
		position: fixed;
		padding: 20px;
		top: 0;
		left: 0;
		height: calc(100vh - 20px);
		background-color: #eeeeee;
		z-index: -1;

		#export-detail-scroll {
			min-width: 300px;
			height: 100%;
			width: calc(100vw - 20px);
			position: relative;
			overflow-y: auto;
			overflow-x: hidden;
			white-space: normal;
			-webkit-overflow-scrolling: touch;
		}

		h1 {
			font-size: 2em;
			margin: 0;
			padding: 0;

			small {
				opacity: 0.6;
				margin-left: 20px;
			}
		}

		@media only screen and (max-width: 470px) {
			h1 {
				font-size: 1em;
			}
		}

		@media only screen and (max-width: 650px) {
			h1 {
				font-size: 1.4em;
			}
		}
	}
</style>
